import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC } from './SpamAllowList/constants'
import {
  getIntelligenceSettingsError,
  getIntelligenceSettingsSuccess,
  toggleSpamFFSuccess,
  updIntelligenceSettingsError,
  updIntelligenceSettingsSuccess,
} from './actions'
import {
  INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
  TOGGLE_SPAM_FF_REQUEST_ASYNC,
  UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
} from './constants'

const getIntelligenceSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE,
      UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.SUCCESS,
      TOGGLE_SPAM_FF_REQUEST_ASYNC.SUCCESS,
      CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS) {
        return matchURL(URL_CONST.settings.community)
      }
      return true
    })
    .mergeMap(() =>
      api.settings
        .getFederationSettings(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getIntelligenceSettingsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getIntelligenceSettingsError, error)))
        .takeUntil(action$.ofType(INTELLIGENCE_SETTINGS_REQUEST_ASYNC.CANCEL))
    )

const updIntelligenceSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .updFederationSettings(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().form.IntelligenceForm.values
      )
      .map((response) => updIntelligenceSettingsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updIntelligenceSettingsError, error)))
      .takeUntil(action$.ofType(UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.CANCEL))
  )

const toggleSpamFFEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(TOGGLE_SPAM_FF_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .toggleSpamFF(action.payload.ffState, store.getState().partnerOptions.selectedCompany?.value)
      .map(() => toggleSpamFFSuccess())
      .catch((error) => Observable.of(epicsErrorHandler(updIntelligenceSettingsError, error)))
      .takeUntil(action$.ofType(TOGGLE_SPAM_FF_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(
  getIntelligenceSettingsEpic,
  updIntelligenceSettingsEpic,
  toggleSpamFFEpic
)
